import React from 'react';
import './WhyIWalkSection.css';

const WhyIWalkSection = () => {

    const scrollToNewsletter = () => {
        const newsletterElement = document.getElementById('newsletter-signup');
        if (newsletterElement) {
            newsletterElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="why-iwalk-section">
            <h2>Why Digitoe?</h2>
            <div className="features">
                <div className="feature">
                    <img src="/Images/back.png" alt="Feature 1" />
                    <p>Improved chronic outcomes with better handle on their postural health</p>
                </div>
                <div className="feature">
                    <img src="/Images/roll.png" alt="Feature 2" />
                    <p>Increase treatment adherence with our engaging gamified treatments</p>
                </div>
                <div className="feature">
                    <img src="/Images/med.jpeg" alt="Feature 3" />
                    <p>Generating insights from measurable data, integratable with your existing technology</p>
                </div>
            </div>
            
            {/* Added onClick handler here */}
            <button className="request-demo" onClick={scrollToNewsletter}>
                Request Demo
            </button>
        </div>
    );
};

export default WhyIWalkSection;
